import * as Sentry from '@sentry/react';
import {
  configuration,
  environmentName,
  packageVersion,
} from '../../configuration';
import { ApiList } from '../api/ApiList';
import { scrubSetupTokenFromReplayEvent } from '../auth/passwordSetupLink';

export function initSentry(): void {
  Sentry.init({
    dsn: configuration.SENTRY_DSN,
    environment: environmentName,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: scrubSetupTokenFromReplayEvent,
      }),
    ],
    // Release configuration
    release: packageVersion,
    // Session Replay
    replaysOnErrorSampleRate: 1.0, // Set sample rate to 100% when sampling sessions where errors occur
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: Object.values(ApiList),
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 10% of the transactions
  });
}
